import type { PDPVideo } from "@shared/graphql.types";
import { VideoPlayer } from "components/VideoPlayer";
import { SwiperSlide } from "swiper/react";
import { getStaticFile } from "utils/getStaticFile";
import { isStorybook } from "utils/storybookUtils";

import { ProductComparisonRibbon } from "../ProductComparisonRibbon";

export type GalleryImageSlideProps = {
  item: PDPVideo;
  index: number;
  thumbsSize?: number | null;
  isThumbnail?: boolean;
  onClick?: () => void;
  showComparisonRibbon?: boolean;
};

export const GalleryVideoSlide = ({
  item,
  index,
  thumbsSize = null,
  isThumbnail = false,
  onClick,
  showComparisonRibbon = false
}: GalleryImageSlideProps) => {
  return (
    <>
      {showComparisonRibbon && <ProductComparisonRibbon />}
      <SwiperSlide
        key={`full-video-player-${index}`}
        data-testid="swiper-slide"
        style={{
          width: thumbsSize ?? "100%",
          height: thumbsSize ?? "100%",
          position: "relative"
        }}
        onClick={() => onClick?.()}
        onTouchStart={() => onClick?.()}
      >
        <VideoPlayer
          options={{
            html5: {
              nativeTextTracks: false
            },
            playsinline: true,
            autoplay: false,
            controls: isThumbnail ? false : true,
            responsive: true,
            loop: isThumbnail ? true : false,
            fluid: true,
            aspectRatio: "1:1",
            sources: item.sources.map(({ uri, contentType }) => ({
              src: uri,
              type: contentType
            }))
          }}
          description={item.description ?? ""}
          videoProps={{
            title: item.title ?? "",
            "aria-label": item.title ?? "",
            id: "gallery-video-player",
            className:
              "video-js vjs-big-play-centered vjs-show-big-play-button-on-pause gallery-video"
          }}
          coverImageProps={{
            src: item.imageUrl,
            title: item.title ?? "",
            alt: item.title ?? "",
            priority: true,
            quality: 85,
            blurDataURL: getStaticFile("/images/placeholder.svg"),
            sizes: "(max-width: 1024px) 100vw, 50vw",
            placeholder: index === 0 || isStorybook ? "empty" : "blur"
          }}
          videoPosition={`PDP gallery${isThumbnail ? " thumbnail" : ""}`}
          pauseWhenNotInView={true}
          autoPlayWhenScrolledIntoView={true}
          muted={true}
          isPlaceholderEnabled={false}
          isThumbnail={isThumbnail}
        />
      </SwiperSlide>
    </>
  );
};

// Slider sucks, https://github.com/nolimits4web/swiper/issues/4413
GalleryVideoSlide.displayName = "SwiperSlide";
